<template>
  <span
    v-if="emitOnlyClick"
    :class="cssClasses"
    :tabindex="tabIndex"
    @click="emitClick"
  >
    <slot />
  </span>

  <a
    v-else-if="disabled"
    href="#"
    :class="cssClasses"
    :tabindex="tabIndex"
    @click.prevent
  >
    <slot />
  </a>
  <nuxt-link
    v-else
    :to="to"
    :class="cssClasses"
    :tabindex="tabIndex"
    @click="emitClick"
  >
    <slot />
  </nuxt-link>
</template>

<script>
export default {
  name: 'DeactivatableLink',
  props: {
    to: {
      type: [Object, String, Number],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    emitOnlyClick: {
      type: Boolean,
      default: false,
    },
    disabledClass: {
      type: String,
      default: 'disabled',
    },
  },
  emits: ['click'],
  computed: {
    tabIndex() {
      return this.disabled ? -1 : undefined;
    },
    cssClasses() {
      const classes = ['deactivatable-link'];
      if (this.disabled) {
        classes.push(this.disabledClass);
      }
      return classes;
    },
  },
  methods: {
    emitClick() {
      if (this.disabled) return;
      this.$emit('click', this.to);
    },
  },
};
</script>
